export const listMeters = `
   query listMeters($filter: MetersFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listMeters(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              name
              meterCode
              aggregation
              grain
              unit
              resetPolicy
              purpose
              latenessWindowMinutes
              watermarkDelayMinutes
              status
              dimensions {
                 name
                 apiKey
              }
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getMeter = `
   query getMeter($id:ID!) {
       getMeter(id:$id) {
         id
         name
         meterCode
         aggregation
         grain
         unit
         resetPolicy
         purpose
         latenessWindowMinutes
         watermarkDelayMinutes
         status
         dimensions {
           name
           apiKey
         }
         createdByUsername
         createdByUser {
           name
           givenName
           familyName
           email
         }
         created
         updated
       }
}`;
